import styled from '@emotion/styled';
import { Divider } from '@mui/material';

const DividerWithSpace = styled(Divider)({
  marginTop: 8,
  marginBottom: 8,
});

export default DividerWithSpace;
